import { Carousel } from '../core'
import Swiper, { Autoplay, EffectFade } from 'swiper'

$.fn.PageHeader = function() {
  let self = this

  if (self.data('page-header')) {
    return self.data('page-header')
  }

  self.type = self.data('type')
  self.carousel = undefined

  self.initialize_carousel = function() {
    if (self.type == 'carousel') {
      self.carousel = new Swiper(self.find('.swiper-container').get(0), {
        modules: [Autoplay, EffectFade],
        loop: true,
        speed: 500,
        slidesPerView: 1,
        spaceBetween: 0,
        allowTouchMove: false,
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        autoplay: {
          delay: 4500,
        },
      })
    }
  }

  self.initialize_video = function() {
    if (self.type == 'video') {
      self.find('.video-loop').each(function() {
        $(this).VideoLoop()
      })
    }
  }

  return function() {
    self.data('page-header', self)
    self.initialize_carousel()
    self.initialize_video()
    return self
  }()
}
